import { Message, MessageBox, Loading } from "element-ui";
import router from "@/router";
import { historyURL, resolveURLQuery } from "@/utils/historyURL";

export default {
  data: () => ({}),
  async created() {
    this.handleTriggerFunc();
  },
  methods: {
    handleTriggerFunc() {
      const { memorized } = this;
      if (!memorized) {
        return Message({
          message: "引用memorizeURL.js文件后，请添加memorized字段",
          type: "error",
          duration: 5 * 1000
        });
      }
      const { triggerMethods = [] } = memorized;
      triggerMethods.forEach(funcName => {
        const fn = this[funcName];
        this[funcName] = async () => {
          await fn();
          this.updateURL();
        };
      });
      return null;
    },
    updateURL() {
      const { queries = [] } = this.memorized;
      const { path, query: curQuery } = this.$route;
      const query = queries.reduce((params, queryName) => {
        params[queryName] = this[queryName];
        return params;
      }, {});
      const mergeQuery = { ...curQuery, ...query };
      this.$router.push({ path, query: mergeQuery }).catch(() => {});
    }
  },
  beforeRouteEnter(to, from, next) {
    const { path, query } = to;
    const { historyFlag } = query;
    if (historyFlag) {
      const urls = historyURL.get();
      const matches = urls.filter(url => url.includes(path)) || [];
      if (matches.length) {
        const q = resolveURLQuery(matches.pop());
        router.push({ path, query: q }).catch(() => {});
      }
    }
    next();
  }
};
